import { render, staticRenderFns } from "./agregaOportunidaNatural.vue?vue&type=template&id=8604dc20&scoped=true"
import script from "./agregaOportunidaNatural.vue?vue&type=script&lang=js"
export * from "./agregaOportunidaNatural.vue?vue&type=script&lang=js"
import style0 from "./agregaOportunidaNatural.vue?vue&type=style&index=0&id=8604dc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8604dc20",
  null
  
)

export default component.exports